import { GridColDef } from '@mui/x-data-grid';
import { Link } from 'react-router-dom';
import CopyToClipboard from '../common/CopyToClipboard';


export const columns: GridColDef[] = [
  {
    field: 'code', headerName: 'Código', flex: 100,
    renderCell: (params) => (
      <div className='table-column-key'>
        {params.value}
        <span className='table-column-key__copyicon'>
          <CopyToClipboard targetText={params.value} />
        </span>
      </div>
    )
  },
  { field: 'name', headerName: 'Nombre', flex: 200 },
  { field: 'created_date', headerName: 'Fecha de Creación', flex: 150 },
  { field: 'description', headerName: 'Descripción', flex: 400 },
]

export const handleDoubleClickRow = (event: any, setTitleId: any) => {
  setTitleId(event.row.code)
}
